<template>
	<div :class="classes">
		<div class="confirmation-dialog__content">
			<header
				v-if="hasHeader"
				class="confirmation-dialog__header"
			>
				<slot name="header">{{ header }}</slot>
			</header>
			<main
				v-if="hasDescription"
				class="confirmation-dialog__description"
			>
				<slot name="description">
					<span v-html="description"></span>
				</slot>
			</main>
			<footer class="confirmation-dialog__actions">
				<slot name="actions">
					<TeamingButton
						v-for="action in actions"
						:key="action.id"
						:type="action.type"
						:destructive="action.isDestructive"
						:leftIcon="action.leftIcon"
						:rightIcon="action.rightIcon"
						:size="buttonSize"
						@buttonPress="action.onButtonPress(action.id)"
					>
						{{ action.label }}
					</TeamingButton>
				</slot>
			</footer>
		</div>
	</div>
</template>

<script>
import ViewportMixin from "../../mixins/ViewportMixin";
import TeamingButton from "../buttons/TeamingButton.vue";

export default {
	name: "ConfirmationDialog",
	mixins: [ ViewportMixin, ],
	components: {
		TeamingButton,
	},
	props: {
		className: {
			type: String,
			default: "",
		},
		header: {
			type: String,
			default: "",
		},
		description: {
			type: String,
			default: "",
		},
		actions: {
			type: Array,
			default: () => [
				{
					id: "no",
					type: "PRIMARY",
					label: "No",
					isDestructive: true,
					onButtonPress: id => {
						// eslint-disable-next-line no-console
						console.log( "onButtonPress:", id );
					},
				},
				{
					id: "yes",
					type: "PRIMARY",
					label: "Yes",
					isDestructive: false,
					onButtonPress: id => {
						// eslint-disable-next-line no-console
						console.log( "onButtonPress:", id );
					},
				},
			],
		},
	},
	computed: {
		classes() {
			return `confirmation-dialog ${ this.className }`.trim();
		},
		hasHeader() {
			return !!this.header || this.$slots.header;
		},
		hasDescription() {
			return !!this.description || this.$slots.description;
		},
	},
};
</script>

<style lang="scss" scoped>
$confirmation-dialog-overlay-bg-color: $color1-900;
$confirmation-dialog-background-color: $white;
$confirmation-dialog-border-color: $color1-200;
$confirmation-dialog-header-font-color: $color1-700;
$confirmation-dialog-description-font-color: $color1-700;

.confirmation-dialog {
	position: fixed;
	top: 0;
	bottom: 0;
	left: 0;
	width: 100%;
	z-index: 999;
	padding: 1rem;
	background-color: rgba(0, 0, 0, 0.4);
	display: flex;
	flex-direction: column;
	align-content: center;
	justify-content: center;
}

.confirmation-dialog__content {
	padding: 1rem;
	background: $confirmation-dialog-background-color;
	border-radius: .5rem;
	border: 0.0625rem solid $confirmation-dialog-border-color;
	box-shadow: 0rem 2.1875rem 1.875rem -1.25rem rgba(33, 45, 99, 0.2), 0rem .1875rem .375rem rgba(33, 45, 99, 0.15);
	display: flex;
	flex-direction: column;
	justify-content: flex-start;
	gap: 1rem;
	max-width: 20rem;
	margin-right: auto;
	margin-left: auto;

	@include for-size-and-larger('md') {
		max-width: 24rem;
	}
}

.confirmation-dialog__header {
	text-align: left;
	@include font-and-line-for(1);
	font-weight: 600;
	color: $confirmation-dialog-header-font-color;
}

.confirmation-dialog__description {
	text-align: left;
	@include font-and-line-for(0);
	color: $confirmation-dialog-description-font-color;
	flex-grow: 1;
}

.confirmation-dialog__actions {
	display: flex;
	flex-direction: column;
	justify-content: flex-start;
	gap: 0.5rem;

	text-align: left;

	.teamingButton {
		min-width: 2.675rem;
	}

	@include for-size('md') {
		flex-direction: row;
		gap: 1rem;
	}
}
</style>
